
export default {
  name: 'ComponentContactForm',
  components: {},
  props: {
    firstNameField: {
      type: Boolean,
      required: false,
      default: true
    },
    lastNameField: {
      type: Boolean,
      required: false,
      default: true
    },
    emailField: {
      type: Boolean,
      required: false,
      default: true
    },
    messageField: {
      type: Boolean,
      required: false,
      default: true
    },
    companyField: {
      type: Boolean,
      required: false,
      default: false
    },
    legalsField: {
      type: Boolean,
      required: false,
      default: true
    },
    termsField: {
      type: Boolean,
      required: false,
      default: true
    },
    buttonTextOverride: {
      type: String,
      required: false,
      default: null
    },
    centerButton: {
      type: Boolean,
      required: false,
      default: false
    },
    centerButtonXS: {
      type: Boolean,
      required: false,
      default: false
    },
    topic: {
      type: String,
      required: false,
      default: 'general'
    }
  },
  data: () => ({
    overlay: {
      show: false
    },
    form: {
      name: '',
      last_name: '',
      first_name: '',
      legals: false,
      terms: true,
      email: '',
      message: '',
      company: ''
    }
  }),
  computed: {
    contactForm() {
      return this.$store.getters['general/contact/contactForm']
    },
    thankYou() {
      return this.$store.getters['general/contact/thankYou']
    },
    loading() {
      return this.$store.getters['general/contact/loading']
    }
  },
  created() {},
  mounted() {
    if (!this.contactForm) {
      this.$store.dispatch('general/contact/getContactForm')
      this.$store.dispatch('general/contact/getThankYou')
    }
    this.prefillUserInput()
  },
  methods: {
    closeOverlay() {
      this.overlay.show = false
      this.$refs.contactForm.reset()
    },
    trackErrors() {
      var errorKeys = Object.keys(this.form).filter((inputName) => {
        let element = document.querySelector('[name="' + inputName + '"]')
        return element && !element.validity.valid
      })
      if (errorKeys.length > 0) {
        this.pushEvent({
          eventName: 'contact_form_fail',
          eventDetails: {
            topic: this.topic,
            error_type: errorKeys.join(':'),
            form_type: 'contact lead'
          }
        })
      }
    },
    prefillUserInput() {
      let rawItem = localStorage.getItem('contactForm')
      if (rawItem) {
        let item = JSON.parse(rawItem)
        this.form.name = item.name
        this.form.first_name = item.first_name
        this.form.last_name = item.last_name
        this.form.email = item.email
        this.form.company = item.company
        this.form.terms = item.terms
      }
    },
    saveUserInput() {
      let item = {
        name: this.form.name,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        email: this.form.email,
        company: this.form.company
      }
      localStorage.setItem('contactForm', JSON.stringify(item))
    },
    sendForm(e) {
      e.preventDefault()
      this.form.name = `${this.form.first_name} ${this.form.last_name}`
      this.$store
        .dispatch('general/contact/sendContactForm', {
          name: this.form.name,
          email: this.form.email,
          company: this.form.company,
          terms: this.form.terms,
          message: this.form.message,
          legals: this.form.legals
        })
        .then(() => {
          this.saveUserInput()
          this.overlay.show = true
          this.pushEvent({
            eventName: 'contact_form_submit',
            eventDetails: {
              topic: this.topic,
              form_type: 'contact lead'
            }
          })
        })
        .catch(() => {
          this.$refs.contactForm.reset()
          this.pushEvent({
            eventName: 'contact_form_fail',
            eventDetails: {
              topic: this.topic,
              error_type: 'server',
              form_type: 'contact lead'
            }
          })
        })
      return false
    }
  }
}
